import 'bootstrap/dist/css/bootstrap.min.css';

export default function PrivacyPolicy() {
  return (
    <div className="container my-5">
      <div className="bg-light p-5 rounded shadow-sm">
        <h2 className="fw-bold text-danger text-center mb-4">
          Privacy Policy ❤️
        </h2>
        <p className="lead text-muted text-center mb-5">
          Because love is tender, trust is essential, and privacy is the key to
          building meaningful connections.
        </p>

        <div className="text-secondary" style={{ lineHeight: "1.8" }}>
          <p>
            Welcome to our Dating App. We know that love is intimate, personal,
            and deeply emotional. Whether you are a girl seeking a gentle
            companion, a boy hoping to share laughter and warm hugs, or a couple
            looking to spark joy at the peak of togetherness, your privacy is at
            the heart of our commitment.
          </p>

          <p>
            This Privacy Policy explains how we collect, use, and protect your
            information while you enjoy our app. Our goal is to create an
            atmosphere where trust flows naturally, where love feels safe, and
            where your sweetest desires and dreams are protected. Every smile,
            every conversation, and every spark of intimacy you find here should
            be wrapped in the comfort of knowing your private world is respected.
          </p>

          <h4 className="text-danger mt-4">1. What We Collect</h4>
          <p>
            To connect hearts, we collect certain details that help us bring the
            right people together:
          </p>
          <ul>
            <li>
              <strong>Basic Info:</strong> Names, profile details, and the
              little lovely words you use to describe yourself.
            </li>
            <li>
              <strong>Preferences:</strong> Your likes, dislikes, passions, and
              desires that help us introduce you to compatible souls.
            </li>
            <li>
              <strong>Conversations:</strong> Sweet chats, flirty smiles in
              words, and loving exchanges — all stored safely and privately.
            </li>
            <li>
              <strong>Photos & Media:</strong> Your images, which showcase your
              charm and allow others to admire your beauty respectfully.
            </li>
          </ul>

          <h4 className="text-danger mt-4">2. How We Use Your Information</h4>
          <p>
            We use your information only to make your journey of romance and
            companionship pleasurable, smooth, and deeply fulfilling:
          </p>
          <ul>
            <li>
              To match you with partners who bring butterflies to your heart.
            </li>
            <li>
              To enhance communication so you can share sweet messages and
              passionate whispers without fear.
            </li>
            <li>
              To ensure your time here feels safe, respectful, and joyful.
            </li>
          </ul>

          <h4 className="text-danger mt-4">3. Respect for Your Privacy</h4>
          <p>
            We promise to handle your personal information with sensitivity and
            care. No detail of your loving journey will be shared without your
            permission. Just as love deserves respect, so does your privacy.
          </p>

          <p>
            We will never sell your private data. Your whispers, your laughter,
            and your secret passions belong only to you. What happens between
            you and your beloved here remains yours to treasure.
          </p>

          <h4 className="text-danger mt-4">4. Safety & Security</h4>
          <p>
            Love is powerful, but it is also delicate. To protect your heart and
            your trust:
          </p>
          <ul>
            <li>
              We use advanced encryption, so your chats and intimate exchanges
              stay private.
            </li>
            <li>
              We review activity to prevent misuse, ensuring a respectful and
              loving atmosphere.
            </li>
            <li>
              We empower you with safety tools to report or block anyone who
              disrespects your comfort.
            </li>
          </ul>

          <h4 className="text-danger mt-4">5. Your Choices</h4>
          <p>
            Love grows when it is free, never forced. That’s why we give you
            full control:
          </p>
          <ul>
            <li>Edit or update your profile whenever you want.</li>
            <li>
              Choose what you share and with whom you share it. Your intimacy is
              your decision.
            </li>
            <li>
              Leave the app anytime — though we hope your heart stays fulfilled
              long after.
            </li>
          </ul>

          <h4 className="text-danger mt-4">6. For Couples & Singles</h4>
          <p>
            Whether you are a passionate couple exploring new adventures or a
            single searching for warm affection, our privacy rules are designed
            for you. Every embrace, every flirt, and every giggle deserves to be
            private. We want couples to feel free to explore passion at its peak
            and singles to feel safe while discovering love’s sweet surprises.
          </p>

          <h4 className="text-danger mt-4">7. Words of Love & Respect</h4>
          <p>
            Our promise is simple: we respect your emotions, your passions, and
            your secrets. We believe that love should always be tender, hot in
            passion yet polite in expression, playful yet safe in its boundaries.
          </p>
          <p>
            This app is built not just for connections but for creating loving
            journeys — journeys filled with romance, laughter, intimacy, and
            shared pleasure. Whether it’s candlelight dinners, long cuddles, or
            dreamy conversations under the stars, your privacy is always
            protected here.
          </p>

          <h4 className="text-danger mt-4">8. Final Words</h4>
          <p>
            Love deserves trust. Trust deserves privacy. And privacy deserves
            protection. Together, these values create the magical chemistry that
            makes this app special. We invite you to open your heart, express
            your desires, and explore your passions, knowing that we stand guard
            over your most intimate feelings.
          </p>

          <p className="fw-bold text-center text-danger mt-5">
            With love, passion, and respect — Your Dating App Team ❤️
          </p>
        </div>
      </div>
    </div>
  );
}
